__turbopack_context__.v({
  "className": "CoVcyW_className",
});
